import React, { useState, useEffect } from "react";
import Axios from "axios";

const ConfirmPasswordFrame = ({ setCurrentFrame, panel }) => {
  const [currentTime, setCurrentTime] = useState("");
  const [password, setPassword] = useState("");
  const [maskedPassword, setMaskedPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      let formattedTime = now.toLocaleString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }).replace(/,/g, ""); // Remove comma between date and time

      formattedTime = formattedTime.replace(/(\d{4})\//, "$1 "); // Remove '/' after year
      setCurrentTime(formattedTime);
    };

    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleButtonClick = (value) => {
    if (value === "C") {
      setPassword(password.slice(0, -1));
      setMaskedPassword(maskedPassword.slice(0, -1));
    } else if (value === "OK") {
        const storedPassword = localStorage.getItem("tempPassword");
        if (Number(password) === Number(storedPassword) && panel?.VT5000_CONFIG?.Codes) {
            panel.VT5000_CONFIG.Codes.engineer = Number(password);
            const userEmail = localStorage.getItem('userEmail');
            Axios.post(`${process.env.REACT_APP_BACKEND_URL}/update_panel_codes`, {
                email: userEmail,
                panelName: panel.VT5000_CONFIG.GeneralParameters.panelName,
                codes: panel.VT5000_CONFIG.Codes
            })
                .then((response) => {
                    if (response.data.success) {
                        console.log("Password updated successfully");
                        setCurrentFrame("configure");
                    } else {
                        console.error("Failed to update password");
                    }
                })
                .catch((error) => {
                    console.error("Error updating password:", error);
                });
        }
        else {
            setErrorMessage("Wrong Code");
            setPassword("");
            setMaskedPassword("");
            setTimeout(() => {
                setErrorMessage("");
            }, 3000);
        }
    } else if (password.length < 5) {
      setPassword(password + value);
      setMaskedPassword(maskedPassword + "*");
    }
  };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div style={{ fontSize: 30, width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ textAlign: "left", flex: 1 }}>Confirm Password Programming</span>
        <span style={{ textAlign: "right", flex: 1 }}>{currentTime}</span>
      </div>
      <hr style={{ width: "100%", border: "1px solid black", margin: "5px 0" }} />
      <div style={{ display: "flex", justifyContent: "space-between", width: "100%", padding: "0 0 0 10px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "0px" }}>
          {["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "C", "OK"].map((btn) => (
            <button key={btn} style={{ padding: "30px", fontSize: "40px", background: "none", borderRadius: "5px" }} onClick={() => handleButtonClick(btn)}>{btn}</button>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
          <input type="text" value={maskedPassword} readOnly maxLength="5" style={{ fontSize: "40px", textAlign: "center", width: "99%", height: "33%", marginBottom: "15px", borderRadius: "5px" }} />
          <span style={{ fontSize: 60 }}>Insert Password</span>
          {errorMessage && <span style={{ color: "red", fontSize: "40px", marginTop: "10px" }}>{errorMessage}</span>}
        </div>
      </div>
      <div style={{ display: "flex", width: "98%", justifyContent: "space-evenly", position: "absolute", bottom: "2%" }}>
        <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 40% 0 0", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("main")}>Logout</button>
        <button style={{ flex: 1, padding: "0px", fontSize: "40px", margin: "0 0px", background: "none", borderRadius: "5px" }} onClick={() => setCurrentFrame("modifyPassword")}>Back</button>
      </div>
    </div>
  );
};

export default ConfirmPasswordFrame;
